<template>
    <div name="navigation-bar" class="bar">
        <img class="logo" src="../../../assets/logo_pc.png" />
        <img class="menu" @click="()=> {onClose = !onClose}" v-if="!onClose" src="../../../assets/menu.png" />
        <img class="close" @click="()=> {onClose = !onClose}" v-else src="../../../assets/m_close.png" />
        <div class="navigation" v-if="onClose">
            <span class="element" @click="change('/m/campaign/ranking')">불편접수함</span>
            <span class="element gray">불편 사례 순위<span class="small" style="margin-left: 4px;">준비중</span></span>
            <span class="element" @click="change('/m/campaign/improvement')">이렇게 개선했어요!</span>
            <span class="element" @click="goHome">홈페이지 바로가기</span>
        </div>
        <div class="blur" v-if="onClose">

        </div>
    </div>
</template>

<script>
export default {
    name: 'navigationBar',
    data: function()
    {
        return {
            onClose: false
        }
    },
    methods: {
        change: function(route)
        {   
            this.onClose = !this.onClose
            this.$emit('change', route)
        },
        goHome: function()
        {
            // window.location.href = 'https://m.concierge.soldoc.co.kr';
            window.open('https://m.concierge.soldoc.co.kr/barocarenew?utm_source=UncomfortableMoment_250708&utm_medium=UncomfortableMoment_250708&utm_campaign=UncomfortableMoment_250708&utm_content=UncomfortableMoment_250708&utm_term=UncomfortableMoment_250708', "_blank")
        }
    }
}
</script>

<style scoped>
    .bar {
        position: fixed;
        z-index: 4;
        width: 100%;
        height: 56px;
        background: var(--Gray-00, #FFF);
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;
    }
    .logo {
        width: 104px;
    }
    .menu {
        width: 22px;
        cursor: pointer;
    }
    .navigation {
        position: fixed;
        top: 56px;
        left: 0;
        height: 244px;
        width: 100%;
        background: var(--Gray-00, #FFF);
        z-index: 1;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .blur {
        position: fixed;
        width: 100%;
        height: calc(100vh - 300px);
        top: 300px;
        left: 0;
        background: rgba(167, 167, 167, 0.76);
        backdrop-filter: blur(2px);
        z-index: 1;
    }
    .close {
        width: 22px;
    }
    .element {
        height: 56px;
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;
        align-items: center;
        padding-left: 20px;   
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .gray {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .small {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        border-radius: 3px;
        background: var(--Gray-20, #F3F5F8);
        padding: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/m_uncomfortable/NavigationBar.vue